import React from 'react';
import '../../App.css';
import HeroSection from '../HeroSection';
import BlogFeed from '../BlogFeed';
import Footer from '../Footer';

function Home() {
  return (
    <>
      <HeroSection />
      <BlogFeed />
      <Footer />
    </>
  );
}

export default Home;
